<template>
    <div class="payroll-column-heading" :class="{'is-compact': compact}">
        <button v-if="sortable" type="button" class="column-title" :class="{'is-sorted': active}" :title="sortHint" @click="$emit('sort')">
            <span>{{ label }}</span><span class="sort-arrow" aria-hidden="true">{{ active ? (direction === 'asc' ? '↑' : '↓') : '↕' }}</span>
        </button>
        <span v-else-if="label" class="column-title">{{ label }}</span>
        <button v-if="groupByObject !== null" type="button" role="switch" class="grouping-switch"
            :aria-checked="String(groupByObject)" aria-label="Группировать по объектам" :title="`Группировать по объектам: ${groupByObject ? 'включено' : 'выключено'}`"
            @click="$emit('grouping', !groupByObject)">
            <span class="grouping-switch__track" aria-hidden="true"></span>
            <span v-if="compact">По объектам</span>
            <span v-else>Группировать по объектам <strong>{{ groupByObject ? 'Включено' : 'Выключено' }}</strong></span>
        </button>
        <span v-else class="column-scope-line"><small v-if="scope" class="column-scope" :class="`scope-${scopeKind}`" :title="scopeTitle || scope">{{ scope === 'За весь месяц' ? 'За месяц' : scope }}</small></span>
    </div>
</template>

<script>
export default {
    name: 'PayrollColumnHeading',
    props: {label: String, sortLabel: String, scope: String, scopeKind: String, scopeTitle: String, sortable: {type: Boolean, default: true}, active: Boolean, direction: String, compact: Boolean, groupByObject: {type: Boolean, default: null}},
    computed: {
        sortHint() { return `Сортировать: ${this.sortLabel || this.label}, ${this.active && this.direction === 'asc' ? 'по убыванию' : 'по возрастанию'}${this.scopeTitle ? '. ' + this.scopeTitle : ''}`; }
    }
};
</script>

<style scoped>
.payroll-column-heading { min-width: 0; }
.grouping-switch { display: flex; align-items: center; gap: 8px; width: 100%; min-height: 44px; margin-top: 6px; padding: 6px 8px; border: 1px solid #bacbda; border-radius: 7px; background: #fff; color: #40566c; font-size: 12px; font-weight: 500; line-height: 16px; text-align: left; box-shadow: inset 0 1px 0 #fff; }
.grouping-switch strong { display: block; color: #5b6d7e; font-size: 11px; font-weight: 600; }
.grouping-switch[aria-checked=true] strong { color: #175c94; }
.grouping-switch__track { display: block; position: relative; width: 32px; height: 18px; flex: 0 0 32px; border-radius: 10px; background: #8799aa; border: 1px solid #788b9e; }
.grouping-switch__track::after { content: ''; position: absolute; width: 12px; height: 12px; top: 2px; left: 2px; border-radius: 50%; background: #fff; box-shadow: 0 1px 3px #142c4533; }
.grouping-switch[aria-checked=true] { border-color: #77acd5; color: #175c94; background: #eaf4ff; }
.grouping-switch[aria-checked=true] .grouping-switch__track { background: #2477b7; border-color: #1b679f; }
.grouping-switch[aria-checked=true] .grouping-switch__track::after { left: 16px; }
.grouping-switch:focus-visible { outline: 3px solid #2684bd; outline-offset: 2px; }
.column-title { display: flex; align-items: flex-end; gap: 4px; width: 100%; min-height: 32px; margin: 0; padding: 0; border: 0; background: transparent; color: #334155; font: inherit; font-size: 12px; font-weight: 600; line-height: 16px; text-align: left; }
.column-title > span:first-child { min-width: 0; overflow-wrap: normal; word-break: normal; }
.sort-arrow { flex-shrink: 0; color: #98a5b5; font-size: 12px; font-weight: 400; }
.is-sorted .sort-arrow { color: #1769aa; font-weight: 700; }
button.column-title:hover { color: #1769aa; }
button.column-title:hover .sort-arrow { color: #1769aa; }
button.column-title:focus-visible { outline: 2px solid #2875b9; outline-offset: 3px; border-radius: 2px; }
.column-scope-line { display: flex; align-items: flex-start; min-height: 34px; padding-top: 6px; }
.column-scope { display: inline-block; max-width: 100%; padding: 2px 5px; border-radius: 4px; font-size: 11px; line-height: 12px; font-weight: 600; white-space: normal; overflow-wrap: normal; word-break: normal; }
.scope-object { color: #34688e; background: #e8f1f8; }
.scope-all { color: #5e6c7d; background: #eaf0f4; }
.scope-month { color: #745795; background: #f0ebf7; }
.is-compact .column-title { min-height: 20px; line-height: 14px; }
.is-compact .column-scope-line { min-height: 24px; padding-top: 3px; }
.is-compact .column-scope { padding: 1px 4px; }
.is-compact .grouping-switch { min-height: 28px; margin-top: 2px; padding: 2px 5px; gap: 6px; }
@media (max-width: 900px) {
    .grouping-switch { min-height: 44px; }
}
</style>
